export enum TournamentStatuses {
  RegistrationUpcoming = 'registration upcoming',
  Registering = 'registering',
  CheckInUpcoming = 'check in upcoming',
  CheckIn = 'check in',
  Upcoming = 'tournament upcoming',
}
